import { createFileRoute } from '@tanstack/react-router';
import CountryEdit from '../../../features/baseData/countries/country/edit';
import {
  COUNTRIES_PERMISSIONS,
  createPermissionGuard,
  getPermissionSet,
} from '@bmwe/ui';

export const Route = createFileRoute(
  '/stammdaten/laender/$countryId_/bearbeiten',
)({
  component: CountryEdit,
  beforeLoad: createPermissionGuard(
    getPermissionSet(COUNTRIES_PERMISSIONS, 'EDIT'),
  ),
});

export const EditCountryRoute = Route;
